import React from 'react'
import image1 from '../../Assests/images/landing_page_img1.png'
import image2 from '../../Assests/images/landing_page_img2.png'
import { Link } from 'react-router-dom'


export default function LandingPage() {
    return (
        <div>
            <div className='m-3 bg-[#1D4ED81A] rounded-[20px]' style={{width:'80%',margin:'3% auto',padding:'6% 5%'}}>
                <div style={{width:'95%', margin:'auto'}}>
                    <h2 className='text-[#4A6FB6] text-[56px] font-bold mb-[-15px]'>Welcome</h2>
                    <span className='text-[#4A6FB6] font-bold text-[36px]'>John !</span>
                    <p className='text-[#717576] text-[20px]'>With every activity and lesson, Future Forwarding provides meaningful insights into how you’re doing and where you’re headed. Students and educators alike can view progress clearly, making learning more transparent and empowering.</p>
                </div>

                <div className='flex justify-center gap-[80px] mt-[40px]'>
                    <Link to='/applications'>
                    <div className='bg-white rounded-[20px] p-4 w-80 h-[300px] content-center cursor-pointer hover:text-[#4A6FB6] hover:shadow-custom'>
                        <img className='w-[162px] h-[150px] m-auto' src={image1} alt='image' />
                        <p className='text-[22px] font-bold text-center mt-[40px] '>Applications</p>
                    </div>
                    </Link>
                    <Link to='/progressandanalytics'>
                    <div className='bg-white rounded-[20px] p-4 w-80 h-[300px] content-center cursor-pointer hover:text-[#4A6FB6] hover:shadow-custom'>
                        <img className='w-[120px] h-[150px] m-auto' src={image2} alt='image' />
                        <p className='text-[22px] font-bold text-center mt-[40px]'>Progress</p>
                    </div>
                    </Link>
                </div>
            </div>
        </div>
    )
}